/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text[_ngcontent-%COMP%] {\r\n    font-size: 13px;\r\n    white-space:pre-line;\r\n}\r\n\r\n.text.align-left[_ngcontent-%COMP%] {\r\n    text-align: left;\r\n}\r\n\r\n.read-more[_ngcontent-%COMP%] {\r\n    font-style: italic;\r\n    font-size: 13px;\r\n    color: var(--primary) !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.read-more[_ngcontent-%COMP%]:hover {\r\n    text-decoration: underline !important;\r\n}"];
export { styles as styles };
